// olap-client/src/components/CreateChatModal.jsx
import React, { useState, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '..';
import { SearchUsers } from '../http/ChatAPI';

const CreateChatModal = observer(({ onClose }) => {
  const { chat, user } = useContext(Context); // <-- ДОБАВЛЕНО: user
  const [chatName, setChatName] = useState('');
  const [chatType, setChatType] = useState('group');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  // === ПОЛУЧАЕМ ID ТЕКУЩЕГО ПОЛЬЗОВАТЕЛЯ ===
  const currentUserId = user?.user?.id || JSON.parse(localStorage.getItem('user') || '{}').id;

  const handleSearch = async () => {
  if (searchQuery.length < 2) {
    setSearchResults([]);
    return;
  }
  try {
    setIsSearching(true);
    const data = await SearchUsers(searchQuery);
    
    // === ФИЛЬТРУЕМ ТЕКУЩЕГО ПОЛЬЗОВАТЕЛЯ ===
    const currentUserId = JSON.parse(localStorage.getItem('user') || '{}').id;
    const filteredResults = data.users.filter(u => u.id !== currentUserId);
    
    setSearchResults(filteredResults);
  } catch (e) {
    console.error('Search error:', e);
  } finally {
    setIsSearching(false);
  }
};

  const toggleUser = (user) => {
    // === ДОПОЛНИТЕЛЬНАЯ ЗАЩИТА: не добавляем самого себя ===
    if (user.id === currentUserId) {
      return;
    }
    
    if (selectedUsers.find(u => u.id === user.id)) {
      setSelectedUsers(selectedUsers.filter(u => u.id !== user.id));
    } else {
      if (chatType === 'private' && selectedUsers.length >= 1) {
        setSelectedUsers([user]);
      } else {
        setSelectedUsers([...selectedUsers, user]);
      }
    }
  };

  const handleCreate = async () => {
    try {
      if (chatType === 'private' && selectedUsers.length !== 1) {
        alert('Для приватного чата выберите одного пользователя');
        return;
      }
      if (chatType === 'group' && !chatName.trim()) {
        alert('Введите название чата');
        return;
      }
      if (selectedUsers.length === 0) {
        alert('Добавьте хотя бы одного участника');
        return;
      }

      // === ФИНАЛЬНАЯ ПРОВЕРКА: убираем самого себя из списка ===
      const memberIds = selectedUsers
        .filter(u => u.id !== currentUserId)
        .map(u => u.id);
      
      if (memberIds.length === 0) {
        alert('Нельзя создать чат с самим собой');
        return;
      }
      
      console.log('🔍 Creating chat with users:', memberIds, selectedUsers);
      
      const result = await chat.createChat(chatName, chatType, memberIds);
      
      if (result.existing) {
        alert('Чат с этим пользователем уже существует. Открываю существующий чат.');
      }
      
      onClose();
    } catch (e) {
      alert('Ошибка создания чата: ' + (e.response?.data?.message || e.message));
      console.error(e);
    }
  };

  const handleTypeChange = (newType) => {
    setChatType(newType);
    if (newType === 'private' && selectedUsers.length > 1) {
      setSelectedUsers([selectedUsers[0]]);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '20px',
        width: '500px',
        maxHeight: '80vh',
        overflowY: 'auto'
      }}>
        <h2 style={{ marginTop: 0 }}>Создать чат</h2>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Тип чата:
          </label>
          <select
            value={chatType}
            onChange={(e) => handleTypeChange(e.target.value)}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '6px',
              border: '1px solid #ddd'
            }}
          >
            <option value="group">Групповой чат</option>
            <option value="private">Приватный чат (1-на-1)</option>
          </select>
        </div>

        {chatType === 'group' && (
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Название чата:
            </label>
            <input
              type="text"
              value={chatName}
              onChange={(e) => setChatName(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                borderRadius: '6px',
                border: '1px solid #ddd'
              }}
              placeholder="Введите название чата"
            />
          </div>
        )}

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Поиск пользователей:
          </label>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyUp={handleSearch}
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '6px',
              border: '1px solid #ddd'
            }}
            placeholder="Введите имя, фамилию или телефон (мин. 2 символа)"
          />
          {isSearching && (
            <div style={{ marginTop: '5px', color: '#666', fontSize: '12px' }}>
              Поиск...
            </div>
          )}
        </div>

        {searchResults.length > 0 && (
          <div style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            maxHeight: '200px',
            overflowY: 'auto',
            marginBottom: '15px'
          }}>
            {searchResults.map(user => {
              const isSelected = selectedUsers.find(u => u.id === user.id);
              return (
                <div
                  key={user.id}
                  onClick={() => toggleUser(user)}
                  style={{
                    padding: '10px',
                    borderBottom: '1px solid #eee',
                    cursor: 'pointer',
                    background: isSelected ? '#e3f2fd' : 'white',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 'bold' }}>
                      {user.name} {user.surname}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      {user.phone} • {user.email}
                    </div>
                  </div>
                  {isSelected && (
                    <span style={{ color: '#007bff', fontSize: '18px' }}>✓</span>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {selectedUsers.length > 0 && (
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Выбранные участники ({selectedUsers.length}):
            </label>
            <div style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '10px',
              minHeight: '50px'
            }}>
              {selectedUsers.map(user => (
                <span
                  key={user.id}
                  onClick={() => toggleUser(user)}
                  style={{
                    display: 'inline-block',
                    background: '#007bff',
                    color: 'white',
                    padding: '6px 12px',
                    borderRadius: '16px',
                    marginRight: '8px',
                    marginBottom: '8px',
                    fontSize: '13px',
                    cursor: 'pointer'
                  }}
                >
                  {user.name} {user.surname} ×
                </span>
              ))}
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              border: '1px solid #ddd',
              borderRadius: '8px',
              background: 'white',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Отмена
          </button>
          <button
            onClick={handleCreate}
            disabled={selectedUsers.length === 0 || (chatType === 'group' && !chatName.trim())}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '8px',
              background: selectedUsers.length === 0 || (chatType === 'group' && !chatName.trim()) ? '#ccc' : '#007bff',
              color: 'white',
              cursor: selectedUsers.length === 0 || (chatType === 'group' && !chatName.trim()) ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            Создать чат
          </button>
        </div>
      </div>
    </div>
  );
});

export default CreateChatModal;